import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import "../../css/salesorder.css";
import axios from "axios";
import { confirm } from 'devextreme/ui/dialog';
import { GridLayout } from "../../../common/GridLayout";
import data from "../../../assets/apiRoutes.json";
import { SelectBox } from 'devextreme-react';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import { alert } from 'devextreme/ui/dialog';
import CustomStore from 'devextreme/data/custom_store';
import RenderSelectBoxCell from "../../../common/RenderCell";
import {
    Column,
    DataGrid,
    Editing,
    Lookup,
    Toolbar,
    Item,
    Export,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    RequiredRule,
} from "devextreme-react/data-grid";
import { Button } from 'devextreme-react/button';
import GridLayoutManager from "../../../gridLayoutCustomization/GridLayoutManager";
import { set } from "lodash";
const SearchResultsForDialog = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.accessToken;
    const gridKey = "10A011A1-E91F-4360-8B53-A59B2F357A1E";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const [selectedItemKeys, setSelectedItemKeys] = useState([]);
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    const [selectedDetailDataSource, setDetailDataSource] = useState(null);
    const [warehouseId, setWarehouseId] = useState(null);
    const [itemId, setItemId] = useState(null);
    const [detailRowId,setDetailRowId] = useState(props.data?.detailRowId);
    const [periority, setPeriority] = useState(1);   
    const recordTypes = [{
        ID: "I",
        Text: "Inventory"
    },
    {
        ID: "N",
        Text: "Non Inventory"
    }
    ]
    useEffect(() => {
        const detailDataSource = new CustomStore({
            key: 'rowid',
            load: (loadOptions) => {
                if (detailRowId) {
                    const params = new URLSearchParams({
                        Rowid: detailRowId,
                        ...loadOptions,
                    });

                    const url = `${window._env_.REACT_APP_APIS}/${data.OM.SearchTransactionsDetails}?${params.toString()}`;

                    return fetch(url, {
                        method: 'GET',
                        headers: {
                            'Authorization': `Bearer ${accessToken}`,
                            'access_token': accessToken,
                        }
                    })
                        .then(response => response.json())
                        .then(data => {
                            return data;
                        })
                        .catch(error => {
                            console.error('Error fetching data:', error);
                            throw error;
                        });
                }
            },
            insert: (values) => {
                // Add the logic to send new row data to the server
                if(props.headerRowId===undefined || props.headerRowId===null){
                    alert('Please select transaction number','Error');
                    return;
                }
                const formData = new FormData();
                values.headerRowId = props.headerRowId;
                formData.append("values", JSON.stringify(values));

                return fetch(`${window._env_.REACT_APP_APIS}/${data.OM.InsertTransactionDetail}`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${accessToken}`,
                        'access_token': accessToken,
                    },
                    body: formData,
                })
                    .then(async response => {
                        if (!response.ok) {
                            const errorDetails = await response.text(); // Read error details
                            throw new Error(errorDetails);
                        }
                        return response.json();
                    }).then((result) => {
                        setDetailRowId(result.transactionData.rowid);
                    });
            },
            update: (key, values) => {
                return new Promise((resolve, reject) => {
                    const formData = new FormData();
                    values.headerRowId = props.data.headerRowId??props.headerRowId;
                    formData.append("values", JSON.stringify(values)); // Add the JSON string of `values`

                    fetch(`${window._env_.REACT_APP_APIS}/${data.OM.AllocateAvailableQuantities}`, {
                        method: "PUT",
                        headers: {
                            access_token: accessToken,
                            Authorization: `Bearer ${accessToken}`,
                            key: key, // Ensure the key follows the required format
                        },
                        body: formData, // Use FormData as the body
                    })
                        .then(async (response) => {

                            if (!response.ok) {
                                const errorDetails = await response.text(); // Read error details
                                throw new Error(errorDetails);
                            }
                            return response.json();
                        })
                        .then((result) => {
                            resolve(result.transactionData);
                        })
                        .catch((error) => {
                            console.error("Update Error:", error); // Log error
                            reject(error);
                        });
                });
            },
        });
        setDetailDataSource(detailDataSource);
    }, [props.data, props.headerRowId,detailRowId]);

useEffect(() => {
    setPeriority(props.priorityEntities?.id);
}, [props.priorityEntities]);

    async function setCode1Value(rowData, value) {
        try {
            rowData.userDefinedCode1 = value;
        } catch (error) {
            console.error("Failed to fetch  Code1 :", error);
        }
    }
    async function setCode2Value(rowData, value) {
        try {
            rowData.userDefinedCode2 = value;
        } catch (error) {
            console.error("Failed to fetch  Code1 :", error);
        }
    }
    async function setCode3Value(rowData, value) {
        try {
            rowData.userDefinedCode3 = value;
        } catch (error) {
            console.error("Failed to fetch  Code1 :", error);
        }
    }
    async function setCode4Value(rowData, value) {
        try {
            rowData.userDefinedCode4 = value;
        } catch (error) {
            console.error("Failed to fetch  Code1 :", error);
        }
    }
    async function setCode5Value(rowData, value) {
        try {
            rowData.userDefinedCode5 = value;
        } catch (error) {
            console.error("Failed to fetch  Code1 :", error);
        }
    }
    const GetCodeByType = (type) => {
        const items = new DataSource({
            store: createStore({
                loadUrl: `${window._env_.REACT_APP_APIS}/${data.OM.GetCodeByType}`,
                key: 'rowid',
                loadParams: {
                    codeType: type
                },
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            sort: [{ selector: "code", desc: false }],
            paginate: true,
            pageSize: 100
        });
        return items;
    };
    const renderCode1Cell = (cellElement) => {
        const items = GetCodeByType(12)
        const currentValue = cellElement.data.userDefinedCode1;
        return (
            <SelectBox
                dataSource={items}
                valueExpr="code"
                displayExpr="code"
                defaultValue={currentValue}
                acceptCustomValue={true}
                searchEnabled={true}
                searchExpr="Code"
                searchMode="contains"
                onValueChanged={async (e) => {
                    const selectedText = e.component.option('displayValue');
                    cellElement.setValue(selectedText);
                }}
            />
        );
    }
    const renderCode2Cell = (cellElement) => {
        const items = GetCodeByType(13)
        const currentValue2 = cellElement.data.userDefinedCode2;
        return (
            <SelectBox
                dataSource={items}
                valueExpr="code"
                displayExpr="code"
                defaultValue={currentValue2}
                acceptCustomValue={true}
                searchEnabled={true}
                searchExpr="Code"
                searchMode="contains"
                onValueChanged={async (e) => {
                    const selectedText = e.component.option('displayValue');
                    cellElement.setValue(selectedText);
                }}
            />
        );
    }
    const renderCode3Cell = (cellElement) => {
        const items = GetCodeByType(14)
        const currentValue2 = cellElement.data.userDefinedCode3;
        return (
            <SelectBox
                dataSource={items}
                valueExpr="code"
                displayExpr="code"
                defaultValue={currentValue2}
                acceptCustomValue={true}
                searchEnabled={true}
                searchExpr="Code"
                searchMode="contains"
                onValueChanged={async (e) => {
                    const selectedText = e.component.option('displayValue');
                    cellElement.setValue(selectedText);
                }}
            />
        );
    }
    const renderCode4Cell = (cellElement) => {
        const items = GetCodeByType(15)
        const currentValue2 = cellElement.data.userDefinedCode4;
        return (
            <SelectBox
                dataSource={items}
                valueExpr="code"
                displayExpr="code"
                defaultValue={currentValue2}
                acceptCustomValue={true}
                searchEnabled={true}
                searchExpr="Code"
                searchMode="contains"
                onValueChanged={async (e) => {
                    const selectedText = e.component.option('displayValue');
                    cellElement.setValue(selectedText);
                }}
            />
        );
    }
    const renderCode5Cell = (cellElement) => {
        const items = GetCodeByType(16)
        const currentValue2 = cellElement.data.userDefinedCode5;
        return (
            <SelectBox
                dataSource={items}
                valueExpr="code"
                displayExpr="code"
                defaultValue={currentValue2}
                acceptCustomValue={true}
                searchEnabled={true}
                searchExpr="Code"
                searchMode="contains"
                onValueChanged={async (e) => {
                    const selectedText = e.component.option('displayValue');
                    cellElement.setValue(selectedText);
                }}
            />
        );
    }

    return (
        <div>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                ref={dataGrid}
                dataSource={selectedDetailDataSource}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                className={props.searchPanelStatus ? "Popup-GridHeightAccordianOpen" : "Popup-GridHeightAccordianClose"}
                searchExpr="status"
                columnAutoWidth={true}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <Export enabled={true} allowExportSelectedData={true} />

                <Editing
                    mode="cell"
                    allowAdding={true}
                    allowUpdating={true}
                />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <Column
                    dataField="type"
                    caption="Type"
                >
                    <Lookup
                        dataSource={recordTypes}
                        valueExpr="ID"
                        displayExpr="Text"
                    />
                </Column>
                <Column dataField="r_Warehouse"  caption='r_Warehouse' visible={false} />
                <Column dataField="warehouseIdentityId" caption='Warehouse'
                allowEditing={periority !== 1}
                    editCellRender={(cellElement) =>
                        RenderSelectBoxCell({
                            loadUrl: `${window._env_.REACT_APP_APIS}/${data.OM.GetWareHouses}`,
                            key: "rowid",
                            displayExpr: "code",
                            valueExpr: "rowid",
                            accessToken: accessToken,
                            defaultValue: cellElement.data.warehouseIdentityId,
                            onValueChangeCallback: (value, text) => {
                                cellElement.setValue(({ value, text }));
                            },
                        })
                    }
                    setCellValue={(rowData, newValue) => {
                        rowData.warehouseIdentityId = newValue.text;
                        rowData.r_Warehouse = newValue.value;
                    }}>
                    <RequiredRule message="The Warehouse field is required." /></Column>
                    <Column dataField="itemid"  caption='itemid' visible={false}  />
                <Column dataField="itemCode" caption='Item'
                 allowEditing={periority !== 1}
                  editCellRender={(cellElement) =>
                    RenderSelectBoxCell({
                        loadUrl: `${window._env_.REACT_APP_APIS}/${data.OM.GetItems}`,
                        key: "rowid",
                        displayExpr: "code",
                        valueExpr: "rowid",
                        accessToken: accessToken,
                        defaultValue: cellElement.data.itemCode,
                        loadParams: {
                            RWarehouse: function () {
                                return cellElement.data.r_Warehouse;
                            }
                        },
                        onValueChangeCallback: (value, text) => {
                            cellElement.setValue(({ value, text }));
                        },
                    })
                }
                setCellValue={(rowData, newValue) => {
                    rowData.itemCode = newValue.text;
                    rowData.itemid = newValue.value;
                }}
                ></Column>
                <Column dataField="lotRowId"  caption='LotRowId' visible={false} />
                <Column dataField="lotCode" caption='Lot' editCellRender={(cellElement) =>
                    RenderSelectBoxCell({
                        loadUrl: `${window._env_.REACT_APP_APIS}/${data.OM.GetLots}`,
                        key: "rowid",
                        displayExpr: "code",
                        valueExpr: "rowid",
                        accessToken: accessToken,
                        defaultValue: cellElement.data.lotCode,
                        loadParams: {
                            masterRowId: function () {
                                return cellElement.data.itemid;
                            }
                        },
                        onValueChangeCallback: (value, text) => {
                            cellElement.setValue(({ value, text }));
                        },
                    })
                }
                setCellValue={(rowData, newValue) => {
                    rowData.lotCode = newValue.text;
                    rowData.lotRowId = newValue.value;
                }}
                >
                </Column>
                <Column dataField="quantityOrdered" caption='Ordered' format={{
                    type: 'fixedPoint',
                    precision: 2
                }} />

                <Column dataField="unitPrice" caption={detailRowId?'New Price':'Unit Price'} format={{
                    type: 'fixedPoint',
                    precision: 2
                }} />

                <Column dataField="userDefinedCode1" visible={false} editCellRender={renderCode1Cell} setCellValue={setCode1Value} caption='Code1' >
                </Column>
                <Column dataField="userDefinedCode2" visible={false} editCellRender={renderCode2Cell} setCellValue={setCode2Value} caption='Code2' >
                </Column>
                <Column dataField="userDefinedCode3" visible={false} editCellRender={renderCode3Cell} setCellValue={setCode3Value} caption='Code3' >
                </Column>
                <Column dataField="userDefinedCode4" visible={false} editCellRender={renderCode4Cell} setCellValue={setCode4Value} caption='Code4' >
                </Column>
                <Column dataField="userDefinedCode5" visible={false} editCellRender={renderCode5Cell} setCellValue={setCode5Value} caption='Code5' >
                </Column>
                <Column dataField="userDefinedQuantity1" visible={false} caption='Quantity1' ></Column>
                <Column dataField="userDefinedQuantity2" visible={false} caption='Quantity2' ></Column>
                <Column dataField="userDefinedQuantity3" visible={false} caption='Quantity3' ></Column>
                <Column dataField="userDefinedQuantity4" visible={false} caption='Quantity4' ></Column>
                <Column dataField="userDefinedQuantity5" visible={false} caption='Quantity5' ></Column>
                <Column dataField="userDefinedDate1" dataType="date" format="MM/dd/yyyy" visible={false} caption='Date1' ></Column>
                <Column dataField="userDefinedDate2" dataType="date" format="MM/dd/yyyy" visible={false} caption='Date2' ></Column>
                <Column dataField="userDefinedDate3" dataType="date" format="MM/dd/yyyy" visible={false} caption='Date3' ></Column>
                <Column dataField="userDefinedDate4" dataType="date" format="MM/dd/yyyy" visible={false} caption='Date4' ></Column>
                <Column dataField="userDefinedDate5" dataType="date" format="MM/dd/yyyy" visible={false} caption='Date5' ></Column>
                <Column dataField="userDefinedReference1" visible={false} caption='Reference1' ></Column>
                <Column dataField="userDefinedReference2" visible={false} caption='Reference2' ></Column>
                <Column dataField="userDefinedReference3" visible={false} caption='Reference3' ></Column>
                <Column dataField="userDefinedReference4" visible={false} caption='Reference4' ></Column>
                <Column dataField="userDefinedReference5" visible={false} caption='Reference5' ></Column>
                <Toolbar>
                    <Item
                   disabled={props.data?.detailRowId ? true : false}
                        name="addRowButton"
                    />
                    <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
        </div>
    )
};

export default SearchResultsForDialog;